import { Callbacks } from '../../base/Callbacks';
/**
 * Callbacks on page loaded.
 */
export class PageLoad extends Callbacks {
    constructor() {
        super(false);
        this._loaded = false;
        this._init();
    }
    get loaded() {
        return this._loaded;
    }
    _setEvents() {
        if (document.readyState === 'complete') {
            this._handleLoaded();
        }
        else {
            window.addEventListener('load', () => {
                this._handleLoaded();
            });
        }
    }
    /**
     * When the page is loaded.
     */
    _handleLoaded() {
        const app = this._app;
        const { prefix } = app;
        this._loaded = true;
        app.html.classList.remove(`${prefix}loading`);
        app.body.classList.remove(`${prefix}loading`);
        app.html.classList.add(`${prefix}loaded`);
        this.tbt('', false);
    }
    /**
     * Add a callback on page load.
     * If the page is already loaded, the callback will be immediately triggered.
     */
    onLoaded(callback) {
        if (this.loaded) {
            callback();
            return undefined;
        }
        return this.add('', callback.bind(this));
    }
}
